module.exports = __webpack_public_path__ + "media/images/fields-icon-nav-69a8818dd42f6e058c40697332193d1c.svg";